
  <file-node *ngFor="let cur of _files" [file]="cur" [selected]="_selectedFilesStore" (change)="changed($event)"></file-node>